import About from "./about/About";
import ContactSection from "./contact/Contact";
import Hero from "./hero/hero"
import 'aos/dist/aos.css';

import AOS from 'aos';
import { useEffect } from "react";
import Services from "./services/Services";
import Features from "./features/Features";
import Gallery from "./gallery/Gallery";


const Home = () => {

    useEffect(() => {
        AOS.init({ duration: 1000 });
    }, []);

    return (
        <>
            <Hero />
            <About />
            <Services />

            <Gallery />
            <Features />
            <ContactSection />
        </>

    )
}

export default Home;